import { USERROLE } from "@/constants";
import { MDMCommandType } from "@/view-models/Common/CommonViews";
import type { ScopedRole, UserProfileView } from "@/view-models/Common/UserProfileView";

export class AccessibleCommandType {
  accessibleCommands: MDMCommandType[];
  scopedRoles: ScopedRole[];
  isParagraphEnable: boolean;
  isAfstlutParagraphEnable: boolean;
  isHovedomraadeEnable: boolean;
  isAfstlutHovedomraadeEnable: boolean;
  isAktivitetsomraadeEnable: boolean;
  isAfstlutAktivitetsomraadeEnable: boolean;
  isHovedkontoEnable: boolean;
  isAfstlutHovedkontoEnable: boolean;
  isUnderkontoEnable: boolean;
  isAfstlutUnderkontoEnable: boolean;
  isMinisteransvarsomraadeEnable: boolean;
  isVirksomhedEnable: boolean;
  isRegnInstEnable: boolean;
  isBogfoeringskredsEnable: boolean;
  isDelregnskabEnable: boolean;
  isEANNumberEnable: boolean;
  isProcessstyring: boolean;
  isProcesrettigheder: boolean;
  isRequiredAdmin: boolean;
  isForwardAccessandVariableGrant: boolean;
  isSubmitBookkeepingToTheStateAccounts: boolean;
  isStandardKontoEnable: boolean;
  isRegnskabskontoEnable: boolean;
  hasAccessToProcessTab: boolean;
  hasAccessActivitiesTab: boolean;
  hasAccessToProcess: boolean;
  hasPeriodsPermission: boolean;
  hasMoveRegnskabsstruktur: boolean;
  hasReopenDelregnskabPermission: boolean;
  hasReopenDelregnskabBySameYearValidation: boolean;
  hasCloseDelregnskabWithoutValidationPermission: boolean;
  hasEditAfterKonteringSlutPermission: boolean;
  hasCloseEANNumberPermission: boolean;
  hasAccessLoengrupperTab: boolean;
  hasAccessToEditLoengrupperOrFaellesskaber: boolean;
  hasAccessKontobroerTab: boolean;

  constructor(userProfile: UserProfileView) {
    this.accessibleCommands = userProfile.accessiblePermissions;

    this.scopedRoles = userProfile.scopeRoles;

    this.isParagraphEnable = this.isContainRole(MDMCommandType.Paragraf);
    this.isAfstlutParagraphEnable = this.isContainRole(MDMCommandType.AfstlutParagraf);
    this.isHovedomraadeEnable = this.isContainRole(MDMCommandType.Hovedomraade);
    this.isAfstlutHovedomraadeEnable = this.isContainRole(MDMCommandType.AfstlutHovedomraade);
    this.isAktivitetsomraadeEnable = this.isContainRole(MDMCommandType.Aktivitetsomraade);
    this.isAfstlutAktivitetsomraadeEnable = this.isContainRole(
      MDMCommandType.AfstlutAktivitetsomraade
    );
    this.isHovedkontoEnable = this.isContainRole(MDMCommandType.Hovedkonto);
    this.isAfstlutHovedkontoEnable = this.isContainRole(MDMCommandType.AfstlutHovedkonto);
    this.isUnderkontoEnable = this.isContainRole(MDMCommandType.Underkonto);
    this.isAfstlutUnderkontoEnable = this.isContainRole(MDMCommandType.AfstlutUnderkonto);
    this.isMinisteransvarsomraadeEnable = this.isContainRole(MDMCommandType.Ministeransvarsomraade);
    this.isVirksomhedEnable = this.isContainRole(MDMCommandType.Virksomhed);
    this.isRegnInstEnable = this.isContainRole(MDMCommandType.RegnskabsfoerendeInstitution);
    this.isBogfoeringskredsEnable = this.isContainRole(MDMCommandType.Bogfoeringskreds);
    this.isDelregnskabEnable = this.isContainRole(MDMCommandType.Delregnskab);
    this.isEANNumberEnable = this.isContainRole(MDMCommandType.EANNummer);
    this.isProcessstyring = this.isContainRole(MDMCommandType.Processstyring);
    this.isProcesrettigheder = this.isContainRole(MDMCommandType.Procesrettigheder);
    this.isRequiredAdmin = this.isContainRole(MDMCommandType.RequiredAdmin);
    this.isForwardAccessandVariableGrant = this.isContainRole(
      MDMCommandType.ForwardAccessandVariableGrant
    );
    this.isSubmitBookkeepingToTheStateAccounts = this.isContainRole(
      MDMCommandType.BogfoeringskredsRegnskabsposteringerPaakrævetTilStatsregnskab
    );
    this.isStandardKontoEnable = this.isContainRole(MDMCommandType.Standardkonto);
    this.isRegnskabskontoEnable = this.isContainRole(MDMCommandType.Regnskabskonto);

    this.hasAccessToProcessTab = this.isProcessstyring || this.isProcesrettigheder;
    this.hasPeriodsPermission = this.isContainRole(MDMCommandType.CreateUpdatePeriodElement);
    this.hasMoveRegnskabsstruktur = this.isContainRole(MDMCommandType.MoveRegnskabsstruktur);
    this.hasAccessActivitiesTab = this.scopedRoles.some(
      (scopedRole) =>
        scopedRole.roleWithoutScope === USERROLE.SADARegnskabsstruktur ||
        scopedRole.roleWithoutScope === USERROLE.SADARegnskabsstrukturCentral ||
        scopedRole.roleWithoutScope === USERROLE.SADACentralAdministrator
    );
    this.hasAccessToProcess = this.isProcessstyring || this.isProcesrettigheder;
    this.hasReopenDelregnskabPermission = this.isContainRole(MDMCommandType.ReopenDelregnskab);
    this.hasCloseDelregnskabWithoutValidationPermission = this.isContainRole(
      MDMCommandType.CloseDelregnskabWithoutValidation
    );
    this.hasReopenDelregnskabBySameYearValidation = this.isContainRole(
      MDMCommandType.ReopenDelregnskabBySameYearValidation
    );
    this.hasEditAfterKonteringSlutPermission = this.isContainRole(
      MDMCommandType.EditAfterKonteringSlut
    );
    this.hasCloseEANNumberPermission = this.isContainRole(MDMCommandType.CloseEANNumber);
    this.hasAccessLoengrupperTab =
      this.isContainRole(MDMCommandType.ReadLoengrupperAndFaellesskaber) ||
      this.isContainRole(MDMCommandType.WriteLoengrupperAndFaellesskaber);
    this.hasAccessToEditLoengrupperOrFaellesskaber = this.isContainRole(
      MDMCommandType.WriteLoengrupperAndFaellesskaber
    );
    this.hasAccessKontobroerTab = this.scopedRoles.some(
      (scopedRole) =>
        scopedRole.roleWithoutScope === USERROLE.SADAKontobroerAdministrator ||
        scopedRole.roleWithoutScope === USERROLE.SADACentralAdministrator
    );
  }

  isContainRole(checkedCommand: MDMCommandType): boolean {
    return this.accessibleCommands.some(
      (commandType) => commandType.toString() === MDMCommandType[checkedCommand]
    );
  }

  isContainRoleString(checkedCommand: string): boolean {
    return this.accessibleCommands.some(
      (commandType) => commandType.toString().toLowerCase() === checkedCommand.toLowerCase()
    );
  }
}
